let guard = null;

export const setNavigationGuard = (next) => {
  guard = next;
  return () => {
    if (guard === next) guard = null;
  };
};

export const requestNavigation = (href) => {
  if (!guard) return true;
  return guard(href) !== false;
};
